export default {
  actions: {
    pushNotification ({ commit }, notification) {
      commit('updateNotification', notification)
    },
    updateUnreadMessages ({ commit }, count) {
      commit('updateUnreadMessages', count)
    }
  },
  mutations: {
    updateNotification (state, notification) {
      state.notification = Object.assign({}, notification)
    },
    updateUnreadMessages (state, count) {
      state.countUnreadMessages = count
    }
  },
  state: {
    notification: {},
    countUnreadMessages: 0
  },
  getters: {
    currentNotification: (state) => state.notification,
    unreadMessages: (state) => state.countUnreadMessages
  }
}
